import { AppService } from '@app/app.service';
import { Component, Input, OnInit } from '@angular/core';
import Article from '@app/edit/article';
import tinymceConfig from '@app/tinymce-config';
declare const tinymce: any;

@Component({
  selector: 'app-write-modal',
  templateUrl: './write.component.html',
  styleUrls: ['./write.component.less'],
})
export class WriteModalComponent implements OnInit {
  @Input() data: Article = {
    id: 1,
    title: '',
    text: '',
    created: 'July 17, 2018',
  };

  @Input() close: Function;
  allAvailableImages: Array<{thumbnail_url: string}>;
  tinymceConfig = tinymceConfig;

  insertImage(url) {
    tinymce.activeEditor.insertContent(`<img alt="Image" src="${url}" />`);
  }

  constructor(
    private appService: AppService,
  ) {}

  ngOnInit() {
    this.appService
      .getAllAvailableImages()
      .subscribe((data: Array<{thumbnail_url: string}>) => { this.allAvailableImages = data; });
  }
}



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/edit/content-panel/integrations/write/write.component.ts